import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Project } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  projectModels: Identifiable<Project>[];
  retrieveProjectModels(
    request: Boundaries["retrieveProjectModels"]["request"],
  ): void;
}

function useRetrieveProjectModels(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveProjectModelsRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveProjectModelsRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveProjectModelsRequestFailure,
    ),
    projectModels: useSelector(selector.getProjectModels),
    retrieveProjectModels: core.retrieveProjectModels,
  };
}

export { useRetrieveProjectModels };
